/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLeftToArc = createReactComponent("outline", "arrow-left-to-arc", "IconArrowLeftToArc", [["path", { "d": "M21 12h-12", "key": "svg-0" }], ["path", { "d": "M13 16l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M12 3a9 9 0 1 0 0 18", "key": "svg-2" }]]);

export { IconArrowLeftToArc as default };
//# sourceMappingURL=IconArrowLeftToArc.mjs.map
